import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-40">
        <div className="max-w-6xl mx-auto px-4" data-id="element-41">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-42">
            {/* Brand */}
            <div className="text-center md:text-left" data-id="element-43">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-44">
                Inglés Nativo en 14 Días
              </h3>
              <p className="text-sm text-slate-500" data-id="element-45">
                Aprende a responder como un nativo en USA
              </p>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm" data-id="element-46">
              <button onClick={() => setPrivacyOpen(true)} className="hover:text-yellow-400 transition-colors underline underline-offset-4" data-id="element-47">
                Privacy Policy
              </button>
              <span className="text-slate-700" data-id="element-48">|</span>
              <button onClick={() => setTermsOpen(true)} className="hover:text-yellow-400 transition-colors underline underline-offset-4" data-id="element-49">
                Terms of Service
              </button>
            </div>

            {/* Copyright */}
            <div className="text-sm text-slate-500 text-center md:text-right" data-id="element-50">
              <p data-id="element-51">
                &copy; {new Date().getFullYear()} Todos los derechos reservados
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Privacy Policy" data-id="element-52">
        <div className="prose prose-slate max-w-none" data-id="element-53">
          <p className="text-slate-600 mb-4" data-id="element-54">
            <strong data-id="element-55">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-56">
            1. Información que Recopilamos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-57">
            Cuando compras "Inglés Nativo en 14 Días (USA)", recopilamos
            información necesaria para procesar tu pedido, incluyendo:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-58">
            <li data-id="element-59">Nombre y dirección de correo electrónico</li>
            <li data-id="element-60">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-61">
              Dirección IP y datos de navegación para prevención de fraude
            </li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-62">
            2. Cómo Usamos Tu Información
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-63">
            Utilizamos tu información personal para:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-64">
            <li data-id="element-65">Procesar y entregar tu compra del PDF</li>
            <li data-id="element-66">Enviarte el producto digital y actualizaciones relacionadas</li>
            <li data-id="element-67">Proporcionar soporte al cliente</li>
            <li data-id="element-68">Mejorar nuestros productos y servicios</li>
            <li data-id="element-69">Cumplir con obligaciones legales</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-70">
            3. Protección de Datos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-71">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración. Todos los pagos son procesados a través de
            plataformas seguras que cumplen con los estándares PCI DSS.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-72">
            4. Compartir Información
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-73">
            No vendemos ni alquilamos tu información personal a terceros.
            Podemos compartir información con:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-74">
            <li data-id="element-75">Procesadores de pago para completar transacciones</li>
            <li data-id="element-76">
              Proveedores de servicios que nos ayudan a operar nuestro negocio
            </li>
            <li data-id="element-77">Autoridades legales cuando sea requerido por ley</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-78">
            5. Tus Derechos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-79">Tienes derecho a:</p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-80">
            <li data-id="element-81">Acceder a tu información personal</li>
            <li data-id="element-82">Corregir datos inexactos</li>
            <li data-id="element-83">Solicitar la eliminación de tus datos</li>
            <li data-id="element-84">Oponerte al procesamiento de tu información</li>
            <li data-id="element-85">Retirar tu consentimiento en cualquier momento</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-86">
            6. Cookies
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-87">
            Utilizamos cookies esenciales para el funcionamiento del sitio web y
            cookies analíticas para mejorar tu experiencia. Puedes controlar las
            cookies a través de la configuración de tu navegador.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-88">
            7. Contacto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-89">
            Si tienes preguntas sobre esta política de privacidad o deseas
            ejercer tus derechos, contáctanos en:
          </p>
          <p className="text-slate-700 mb-4" data-id="element-90">
            <strong data-id="element-91">Email:</strong> privacy@ingles14dias.com
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Terms of Service" data-id="element-92">
        <div className="prose prose-slate max-w-none" data-id="element-93">
          <p className="text-slate-600 mb-4" data-id="element-94">
            <strong data-id="element-95">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-96">
            1. Aceptación de Términos
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-97">
            Al comprar y usar "Inglés Nativo en 14 Días (USA)", aceptas estos
            términos de servicio. Si no estás de acuerdo, no uses el producto.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-98">
            2. Descripción del Producto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-99">
            "Inglés Nativo en 14 Días (USA)" es un producto digital (PDF) que
            contiene:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-100">
            <li data-id="element-101">
              20 escenas de conversación en inglés para situaciones reales en
              USA
            </li>
            <li data-id="element-102">Frases nativas con traducción al español</li>
            <li data-id="element-103">Guía de pronunciación y práctica</li>
            <li data-id="element-104">Plan de mantenimiento de 7 minutos diarios</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-105">
            Este es un producto educativo digital. No garantizamos resultados
            específicos, ya que el aprendizaje depende del esfuerzo individual.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-106">
            3. Licencia de Uso
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-107">
            Al comprar el producto, recibes una licencia personal, no
            transferible y no exclusiva para:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-108">
            <li data-id="element-109">Descargar y usar el PDF para tu aprendizaje personal</li>
            <li data-id="element-110">Imprimir una copia para uso personal</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-111">
            <strong data-id="element-112">NO puedes:</strong>
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-113">
            <li data-id="element-114">Compartir, distribuir o revender el producto</li>
            <li data-id="element-115">Publicar el contenido en línea o en redes sociales</li>
            <li data-id="element-116">Modificar o crear obras derivadas</li>
            <li data-id="element-117">Usar el contenido con fines comerciales</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-118">
            4. Pago y Entrega
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-119">
            El precio actual es de $6.39 USD. El pago se procesa de forma segura
            a través de nuestro proveedor de pagos. Después de completar la
            compra, recibirás:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-120">
            <li data-id="element-121">Un email de confirmación inmediato</li>
            <li data-id="element-122">Acceso de descarga instantánea al PDF</li>
            <li data-id="element-123">Acceso de por vida al producto</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-124">
            5. Política de Reembolso
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-125">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecho con el producto, contáctanos dentro de los 30 días
            posteriores a la compra para solicitar un reembolso completo. Debes:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-126">
            <li data-id="element-127">Enviar tu solicitud a refunds@ingles14dias.com</li>
            <li data-id="element-128">Incluir tu número de pedido</li>
            <li data-id="element-129">Explicar brevemente el motivo (opcional)</li>
          </ul>
          <p className="text-slate-700 mb-4" data-id="element-130">
            Procesaremos tu reembolso en 5-7 días hábiles.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-131">
            6. Propiedad Intelectual
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-132">
            Todo el contenido de "Inglés Nativo en 14 Días (USA)", incluyendo
            textos, diseños, gráficos y materiales, está protegido por derechos
            de autor y es propiedad exclusiva de nuestro negocio. Cualquier uso
            no autorizado constituye una violación de estos derechos.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-133">
            7. Limitación de Responsabilidad
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-134">
            Este producto es una herramienta educativa. No garantizamos
            resultados específicos en el aprendizaje del inglés. Tu progreso
            depende de tu dedicación y práctica. No somos responsables de:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-135">
            <li data-id="element-136">Resultados de aprendizaje individuales</li>
            <li data-id="element-137">Oportunidades laborales o sociales</li>
            <li data-id="element-138">Problemas técnicos de descarga (ofrecemos soporte)</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-139">
            8. Modificaciones
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-140">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación. El uso continuado del producto después de los cambios
            constituye tu aceptación de los nuevos términos.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-6 mb-3" data-id="element-141">
            9. Contacto
          </h3>
          <p className="text-slate-700 mb-4" data-id="element-142">
            Para preguntas sobre estos términos, contáctanos en:
          </p>
          <p className="text-slate-700 mb-4" data-id="element-143">
            <strong data-id="element-144">Email:</strong> support@ingles14dias.com
          </p>
        </div>
      </Modal>
    </>;
}